import { render } from "./editar_baremo.vue?vue&type=template&id=1662a586"
import script from "./editar_baremo.vue?vue&type=script&lang=js"
export * from "./editar_baremo.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__